import { CommsEscalationReason, type CommsEscalationMetadata } from "@/src/models/comms-escalation";
import { getPersonName, type NameFields } from "@/src/models/person";

const UNKNOWN_PROVIDER = "N/A";

function outreachNotePrefix(
  referringProvider: NameFields | null | undefined,
  receivingProvider: NameFields | null | undefined
): string {
  const referringProviderName = getPersonName(referringProvider, false) || UNKNOWN_PROVIDER;
  const receivingProviderName = getPersonName(receivingProvider, false) || UNKNOWN_PROVIDER;

  return `Patient referred by Dr. ${referringProviderName} to Dr. ${receivingProviderName}`;
}

export function buildUshvMkcOutreachAssignmentNote(
  referringProvider: NameFields | null | undefined,
  receivingProvider: NameFields | null | undefined
): string {
  return `${outreachNotePrefix(referringProvider, receivingProvider)} - Valerie Health outreaching patient`;
}

// "3 attempts" duplicates MKC's cadence in configuration/sms-follow-up-cadence.ts; nothing validates it.
export function buildUshvMkcOutreachNoResponseNote(
  referringProvider: NameFields | null | undefined,
  receivingProvider: NameFields | null | undefined
): string {
  return `${outreachNotePrefix(referringProvider, receivingProvider)} - Valerie Health made 3 attempts, patient did not respond. Please call the patient.`;
}

// Excludes invalid_phone_number deliberately: it raises the same task type, but nothing was ever
// sent, so "made 3 attempts" would be false and ops has approved no other wording.
export function hasUshvMkcCommsEscalationNote(metadata: CommsEscalationMetadata): boolean {
  return metadata.reason === CommsEscalationReason.CONVERSATION_AUTO_CLOSED;
}

export function resolveUshvMkcCommsEscalationNote(
  metadata: CommsEscalationMetadata,
  referringProvider: NameFields | null | undefined,
  receivingProvider: NameFields | null | undefined
): string | null {
  return hasUshvMkcCommsEscalationNote(metadata)
    ? buildUshvMkcOutreachNoResponseNote(referringProvider, receivingProvider)
    : null;
}
